import CartDeliveryAndTotal from './CartDeliveryAndTotal'

export default CartDeliveryAndTotal
